<template>
  <div class="address-item" :class="{ active: isSelected }">
    <div @click="onChange">
      <div class="flex align-center address-item__content">
        <div class="b-text t-break">{{ dataObj.recipientName }}</div>
        <div class="l-text mg-r-20">{{ phoneDisplay }}</div>
        <div class="icon" v-if="dataObj.isDefault">Default</div>
      </div>
      <div class="mg-t-12 l-text">{{ address }}</div>
    </div>
    <div class="line-bottom mg-t-12"></div>
    <div class="mg-t-12 flex justify-between">
      <div>
        <van-checkbox v-model="dataObj.isDefault" @click.stop="doDefaultChange" checked-color="#FF5A00">{{ $t('default')
        }}</van-checkbox>
      </div>
      <div class="flex align-center icons">
        <div @click.stop="doEdit"><van-icon name="records-o" /> {{ $t('edit') }}</div>
        <div class="mg-l-20" @click.stop="doDelete"><van-icon name="delete-o" /> {{ $t('delete') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { Checkbox, Icon } from 'vant';
import { formatAddressForList } from '@/utils/address';
export default {
  name: 'AddressItem',
  components: {
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
  },
  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    dataObj: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    phoneDisplay() {
      let phone = this.dataObj.recipientPhone || '';
      if (phone.startsWith('62')) {
        phone = phone.substring(2);
      }
      return phone;
    },
    address() {
      return formatAddressForList(this.dataObj);
    }
  },
  data() {
    return {
      checked: false
    }
  },
  methods: {
    ...mapActions('user', [
      'setDefaultAddress'
    ]),
    doEdit() {
      this.$emit('edit', {
        data: this.dataObj
      });
    },
    doDelete() {
      this.$emit('delete', {
        data: this.dataObj
      });
    },
    doDefaultChange() {
      let res = this.setDefaultAddress({
        id: this.dataObj.id
      });
      if (!res || res.code !== 'Success') {
        this.dataObj.isDefault = !this.dataObj.isDefault;
      }
    },
    onChange() {
      this.$emit('change', {
        data: this.dataObj
      });
    }
  }
}
</script>

<style lang="less" scoped>
.address-item {
  background: #ffffff;
  padding: 24px 30px;
  border-radius: var(--border-radius-base);
  border: 1px solid #ffffff;
  margin-top: 24px;

  &:first-child {
    margin-top: 0;
  }

  &.active {
    border: 1px solid #2547F1;
  }

  /deep/ .van-checkbox__label {
    font-size: 24px;
    line-height: 40px;
    color: var(--text-color-gray);
  }
}

.b-text {
  font-weight: 500;
  margin-right: 20px;
  font-size: 28px;
  line-height: 38px;
}

.l-text {
  font-size: 26px;
  line-height: 38px;
  color: var(--text-color-gray);
}

.icon {
  padding: 6px;
  font-size: 22px;
  border: 1px solid #FF5A00;
  color: #FF5A00;
  border-radius: 10px;
}

.icons {
  font-size: 24px;
  color: var(--text-color-gray);
}
</style>
